import App from '../App';
import Box from "@mui/material/Box";

import bimHero from '../images/hero_bim.jpg'
import Stack from "@mui/material/Stack";
import Chip from "@mui/material/Chip";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import Container from "@mui/material/Container";

export default function HomePage() {
    return (
        <App>
            <Box
                sx={{
                    backgroundImage: `url(${bimHero})`,
                    backgroundSize: 'cover', // Ensures the image covers the entire Box
                    backgroundPosition: 'center', // Centers the image
                    height: 'calc(100vh - 400px)', // Sets the height to 100% of the viewport height
                    // width: '100vw',  // Sets the width to 100% of the viewport width
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    overflow: 'hidden', // Prevents scrollbars if the image is slightly larger than the viewport,
                    pb: 12,
                    pt: 12
                }}
            >
                <Container>
                    <Stack  sx={{maxWidth: '500px', display: 'flex', justifyContent: 'flex-start'}} spacing={1} >
                        <Typography fontSize={{sm:'36px', xs: '26px'}} align={'left'}>
                            Технологичные клиники массажа
                            со своей культурой
                        </Typography>
                        <Typography fontSize={{sm: '26px', xs: '16px'}} align={'left'}>
                            Кастомизируемый массаж в пару касаний
                        </Typography>
                        <Stack sx={{pt: 4}} spacing={2}>
                            <Button variant={'contained'} size={'large'} fullWidth={false}
                                    sx={{borderRadius: '25px', fontSize: {sm: '20px', xs: '16px'}, width: '250px'}}
                                    href={'https://app.bimclinics.ru'}
                            >
                                Все процедуры</Button>
                            <Stack direction={'row'} spacing={1}>
                                <Chip
                                    sx={{
                                        '&:hover': {
                                            background: '#aaaaaa',
                                        },
                                        fontSize: {sm: '16px', xs: '14px'}
                                    }}
                                    component={'a'}
                                    clickable
                                    href={encodeURI('https://app.bimclinics.ru?serviceTemplate.title=Массаж спины')}
                                    label={'массаж спины'}
                                >
                                </Chip>
                                <Chip
                                    sx={{
                                        '&:hover': {
                                            background: '#aaaaaa',
                                        },
                                        fontSize: {sm: '16px', xs: '14px'}
                                    }}
                                    component={'a'}
                                    clickable
                                    href={encodeURI('https://app.bimclinics.ru?serviceTemplate.title=Массаж лица')}
                                    label={'массаж лица'}
                                >
                                    ></Chip>
                            </Stack>
                        </Stack>
                    </Stack>
                </Container>
            </Box>
        </App>
    );
}
